import { useEffect } from "react";
import { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { PIN_VERIFY_LOADING_MS } from "@src/hooks/usePin";

export function useCrossFadeSpinner(isBusy: boolean) {
  const contentOpacity = useSharedValue(1);
  const spinnerOpacity = useSharedValue(0);

  useEffect(() => {
    contentOpacity.value = withTiming(isBusy ? 0 : 1, {
      duration: PIN_VERIFY_LOADING_MS,
    });
    spinnerOpacity.value = isBusy ? 1 : withTiming(0, { duration: PIN_VERIFY_LOADING_MS });
  }, [isBusy, contentOpacity, spinnerOpacity]);

  const contentStyle = useAnimatedStyle(() => ({ opacity: contentOpacity.value }));
  const spinnerStyle = useAnimatedStyle(() => ({ opacity: spinnerOpacity.value }));

  return { contentStyle, spinnerStyle };
}
